export enum DESIGNER_AGENT {
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=828151754
     */
    CREATE_WITH_PAGE_WRITER_AGENT = 'CONTRIBUTION_MENU.CREATE_WITH_PAGE_WRITER_AGENT',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=819585847
     */
    START_GENERATION_USER_MESSAGE = 'DESIGNER_AGENT.START_GENERATION_USER_MESSAGE',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=824059969
     */
    WIDGET_UPDATE_REASON_HIGHLIGHT_BUTTON_LABEL = 'DESIGNER_AGENT.WIDGET_UPDATE_REASON_HIGHLIGHT_BUTTON_LABEL',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=816622765
     */
    WIDGET_UPDATE_REASON_LABEL = 'DESIGNER_AGENT.WIDGET_UPDATE_REASON_LABEL',
}
